export default __webpack_public_path__ + "static/media/Leggings of Reflection.7c6edaf5.jpg";